import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetAllSubCategoryQuery } from 'App/services/subCategoryServiceApi';
import { useCreateChapterMutation } from 'App/services/chapterServiceApi';
import { useGetBySubCategoryIdQuery } from 'App/services/chapterServiceApi';
import { useGetByCatIdQuery } from 'App/services/subCategoryServiceApi';
import Loading from 'components/Loading';
import NotFound from 'components/NotFound';
import { toast } from 'react-toastify';

export default function ChapterFormDialogue() {

  const location = useLocation();
  const data = location.state || {};
  // console.log(data)
  const [open, setOpen] = React.useState(false);
  const [chapterName, setChapterName] = React.useState('');
  const [subcategoryId, setSubCategoryId] = React.useState(data.data);
  const [categoryId, setCategoryId] = React.useState(data.categoryId);

  const navigate = useNavigate();





 


  const { data: chapters, error: chaptersError, isLoading: chaptersLoading , isFetching : chapterFetching, isError: ischaptersError} = useGetAllSubCategoryQuery();

  const [createChapter, { isLoading, isError, error }] = useCreateChapterMutation();

  
  if (chaptersLoading || chapterFetching) {
    return <Loading />;
  }

  if (ischaptersError) {
 
    return <NotFound
    
    error={chaptersError} />;
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddChapter = async (event) => {
    event.preventDefault();

    if(chapterName){
    try {
      await createChapter({ name: chapterName, subcategoryId, categoryId });
      toast.success("Chapter Successfully Created!");
      // navigate('/subcategory');
      handleClose();
      setChapterName('')

    } catch (err) {
      console.error('Failed to add chapter: ', err);
      toast.error("Something went wrong!!")

    }
  }
  else{
    toast.error("Required to subCategory Field name");

  }

  };

  return (
    <React.Fragment>
      <Button variant="contained" color="light" onClick={handleClickOpen}>
        Add Chapter
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: handleAddChapter,
        }}
      >
        <DialogTitle>Add Chapter</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Enter the name and select the sub category for the Chapter:
          </DialogContentText>
          <TextField
            autoFocus
            // required
            margin="dense"
            id="name"
            name="name"
            label="Chapter Name"
            type="text"
            fullWidth
            value={chapterName}
            onChange={(e) => setChapterName(e.target.value)}
            error={!!error}
          />
          <Select
            required
            fullWidth
            sx={{  height: 40 }}
            value={subcategoryId}
            onChange={(e) => setSubCategoryId(e.target.value)}
            displayEmpty
            disabled
          >
            <Select
            required
            fullWidth
            sx={{ height: 40 }}
            value={categoryId}
            onChange={(e) => setCategoryId(e.target.value)}
            displayEmpty
            disabled
          ></Select>
            <MenuItem value="" >Select sub Category</MenuItem>
            {chaptersLoading ? (
              <MenuItem disabled>Loading...</MenuItem>
            ) : chaptersError ? (
              <MenuItem disabled>Error loading categories</MenuItem>
            ) : (
              chapters && chapters.length>=0 && chapters.map((chapter) => (
                <MenuItem key={chapter.id} value={chapter.id}>
                  {chapter.name}
                </MenuItem>
              ))
            )}
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" disabled={isLoading} name="submit">
            Add {isLoading && 'Loading...'}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
